import { useCallback, useEffect } from "react";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";
import { UsePanelEquipoModeloInsertar } from "./UsePanelEquipoModeloInsertar";
import { ComboBoxComponent } from "../../../../../components/comboBox/ComboBoxComponent";
import { useComboModelos } from "../../../../../hooks/combosHooks/useComboModelos";

export interface IPanelEquipoModeloInsertar extends IOpenPanel {}

export const PanelEquipoModeloInsertar = (props: IPanelEquipoModeloInsertar) => {

  const { dataComboModelos, listarCombo } = useComboModelos();

  useEffect(() => {
  if (props.isOpen) {
    listarCombo();
  }
}, [props.isOpen]);

  const {
    setRequestAux,
    postInsertarEquipoModelo,
    loading,
    disableForm,
    reset,
    mensaje,
    status,
  } = UsePanelEquipoModeloInsertar({
    ...props,
    reloadCombo: listarCombo,
  });

  const onRenderFooter = useCallback(
    () => (
      <PanelFooter
        texto="Guardar"
        texto2="Salir"
        disableButton={disableForm}
        onClick={postInsertarEquipoModelo}
        onDismiss={reset}
      />
    ),
    [disableForm]
  );

  return (
    <PanelDrawer
      isOpen={props.isOpen}
      onDismiss={reset}
      textHeader="Modelo Auxiliar"
      status={status}
      mensaje={mensaje}
      loading={loading}
      onRenderFooter={onRenderFooter}
    >
      <ComboBoxComponent
        text="Modelo Equipo:"
        placeholder="Seleccione un modelo"
        data={dataComboModelos}
        onOptionSelect={(e, option) => {
          if (option) {
            setRequestAux({
              equipoModeloId: String(option.key),
            });
          }
        }}
      />
    </PanelDrawer>
  );
};